import { IAppEntity } from "../../entities";
import React from "react";
import { VendorItemService } from "../../../services/catalogs/VendorItemService";
import { VendorItemDetail } from "../../../components/Pages/Catalogs/VendorItem/VendorItemDetail";
import { CreateVendorItemDto } from "../../../dtos/catalogs/vendoritem/CreateVendorItemDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupVendorItem } from "../../../components/Shared/NewForms/NFLookupVendorItem";
import VendorItemList from "../../../components/Pages/Catalogs/VendorItem/VendorItemList";

export const VendorItem: IAppEntity = {
  entityType: "catalog",
  title: "Vendor Item",
  pluralTitle: "Vendor Item",
  apiUrl: "VendorItems",
  apiEnum: ReferenceTypes.CatalogVendorItem,
  getDetailViewComponent(
    model: any,
    modelUpdatedEvent: (model: any) => void
  ): any {
    return React.createElement(VendorItemDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    });
  },
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(VendorItemList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupVendorItem, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService() {
    return new VendorItemService(this.apiUrl);
  },
  getEmptyModel(): CreateVendorItemDto {
    return {
      name: "",
      createdDate: new Date(),
    };
  },
};

// description?:string;
// vendorID?:string; //Shesacvlelia
// vendorParentId?:string; //Shesacvlelia
// productId?:string; //Shesacvlelia
// vendorvendorUnitIdID?:string; //Shesacvlelia
// productUnitId?:string; //Shesacvlelia
